import React, { memo } from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
import { useTheme } from '../../../../utils/styles';
const Control = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const theme = useTheme();
  const {
    isFuzzy,
    beforeControl,
    afterControl,
    onMouseDown
  } = props.selectProps;
  props.innerProps.onMouseDown = onMouseDown;
  return /*#__PURE__*/React.createElement(components.Control, props, isFuzzy && /*#__PURE__*/React.createElement(Icon, {
    className: "hoi-poi-select__search-indicator",
    name: "searchRaw",
    size: "raw",
    color: theme.colors.grey[500]
  }), beforeControl && beforeControl, children, afterControl && afterControl);
};
export default /*#__PURE__*/memo(Control);